import MojitoCore from 'mojito/core';
import AbsolutePane from 'presentation/components/absolute-pane/index.js';
import ImageButton from 'presentation/components/image-button/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';

const classUtils = MojitoCore.Base.classUtils;

export default function RemoveButton({ onClick, mojitoTools, class: className }) {
    const { config } = mojitoTools;
    const buttonElement = (
        <ImageButton
            class={classUtils.classNames('ta-RemoveButton', className)}
            onClick={onClick}
            config={config.imageButton}
        />
    );
    return config.useAbsolutePosition ? (
        <AbsolutePane config={config.container}>{buttonElement}</AbsolutePane>
    ) : (
        <FlexPane config={config.flexContainer}>{buttonElement}</FlexPane>
    );
}
